export const errorOnGettingDailyPredictionData = () => {
  alert("couldn't get daily prediction data")
}

export const errorOnGettingTwoWeekPredictionData = () => {
  alert("couldn't get two week prediction data")
}